// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsSection} from '@app/features/app/components/dialogs/shared/SettingsSection';
import {ComponentDispatch} from '@app/features/platform/utils/ComponentBus';
import styles from '@app/features/user/components/modals/tabs/account_security_tab/AccountNavigationSection.module.css';
import {
	getUserSettingsTabLabel,
	type UserSettingsSubtabType,
} from '@app/features/user/components/settings_utils/SettingsConstants';
import {ACCOUNT_NESTED_TAB_TYPES} from '@app/features/user/components/settings_utils/SettingsNavigationGroups';
import type {UserSettingsTabType} from '@app/features/user/components/settings_utils/SettingsSectionRegistry';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {ArrowRightIcon} from '@phosphor-icons/react';
import {observer} from 'mobx-react-lite';

const ACCOUNT_PAGES_DESCRIPTOR = msg({
	message: 'Account pages',
	comment: 'Section title for nested account settings navigation.',
});

const ACCOUNT_PAGES_DESCRIPTION_DESCRIPTOR = msg({
	message: 'Manage privacy, app access, blocked users, and devices from your account area.',
	comment: 'Description for nested account settings navigation.',
});

export const AccountNavigationSection = observer(() => {
	const {i18n} = useLingui();
	const handleSelect = (tab: UserSettingsTabType) => {
		ComponentDispatch.dispatch('USER_SETTINGS_TAB_SELECT', {tab});
	};
	return (
		<SettingsSection
			id={'account_pages' as UserSettingsSubtabType}
			title={i18n._(ACCOUNT_PAGES_DESCRIPTOR)}
			description={i18n._(ACCOUNT_PAGES_DESCRIPTION_DESCRIPTOR)}
			data-flx="user.account-security-tab.account-navigation-section.settings-section"
		>
			<div className={styles.pageList} data-flx="user.account-security-tab.account-navigation-section.page-list">
				{ACCOUNT_NESTED_TAB_TYPES.map((tab) => (
					<button
						key={tab}
						type="button"
						className={styles.pageButton}
						onClick={() => handleSelect(tab)}
						data-flx="user.account-security-tab.account-navigation-section.page-button.select"
					>
						<span
							className={styles.pageLabel}
							data-flx="user.account-security-tab.account-navigation-section.page-label"
						>
							{getUserSettingsTabLabel(i18n, tab)}
						</span>
						<ArrowRightIcon
							size={16}
							weight="bold"
							className={styles.pageIcon}
							aria-hidden="true"
							data-flx="user.account-security-tab.account-navigation-section.page-icon"
						/>
					</button>
				))}
			</div>
		</SettingsSection>
	);
});
